export const odeProfitMotives = [
  { label: "Empresa con fines económicos", value: "PROFIT" },
  { label: "Empresa con fines sociales", value: "NON_PROFIT" }
];
